import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

import Flickity from 'flickity';
import fade from "flickity-fade";
import 'flickity/dist/flickity.min.css';


export class InfoLanding extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeSlideClass: 'casino'
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.props.showMenuFn(false);

        var that = this;

        this.flickityOptions = {
             fade: true,
            wrapAround: true,
            // selectedAttraction: 1,
            // friction: 1,
            on: {
                change: function (index) {
                    var slides = ['casino', 'jackpot', 'poker'];
                    that.setState({ activeSlideClass: slides[index]});
                }
            }
        }

        this.flickity = new Flickity('.info-landing-flickity-slider', this.flickityOptions || {});
    }

    componentWillUnmount() {
        this.props.showLoadingFn(false);
    }

    renderCasinoPage(hideBg) {
        return <>
            <div className={"landing-info-casino " + (hideBg ? '' : 'bg-image')}>
                <div className="logo"></div>
                <div className="container">
                    <div className="background-items"></div>
                    <div className="left-side">
                        <div className="girl"></div>
                    </div>
                    <div className="right-side">
                        <div className="content">
                            <p className="title">NAJVEĆI CASINO</p>
                            <p className="text">Pridruži se najvećem i dokazano najboljem domaćem Casino-u koji broji više od <strong>300.000 igrača i preko 1.000 igara!</strong></p>
                            <div className="gumbi-container">
                                <a className="m-auto" href="https://m.supersport.hr/registracija"><button className="registriraj" type="button">REGISTRIRAJ SE SADA</button></a>
                                <a className="m-auto" href="https://mcasino.supersport.hr/?promocija=free-spins"><button className="kasino" type="button">NASTAVI NA CASINO <span className="icon ico-chevron-right"></span></button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    renderPokerPage(hideBg) {
        return <>
            <div className={"landing-info-poker " + (hideBg ? '' : 'bg-image')}>
                <div className="logo"></div>
                <div className="container">
                    <div className="background-items"></div>
                    <div className="left-side">
                        <div className="girl"></div>
                    </div>
                    <div className="right-side">
                        <div className="content">
                            <p className="title">NAJVEĆI POKER</p>
                            <p className="text">Supersport Poker sa više od 20 uvijek dostupnih cash stolova te <strong>dostupan za iOS i Android</strong> mobilne uređaje! Pridruži se i zaigraj!</p>
                            <div className="gumbi-container">
                                <a className="m-auto" href="https://m.supersport.hr/registracija"><button className="registriraj" type="button">REGISTRIRAJ SE SADA</button></a>
                                <a className="m-auto" href="https://mcasino.supersport.hr/poker"><button className="kasino" type="button">NASTAVI NA POKER <span className="icon ico-chevron-right"></span></button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    renderJackpotPage(hideBg) {
        return <>
            <div className={"landing-info-jackpot " + (hideBg ? '' : 'bg-image')}>
                <div className="logo"></div>
                <div className="container">
                    <div className="background-items"></div>
                    <div className="left-side">
                        <div className="girl"></div>
                    </div>
                    <div className="right-side">
                        <div className="content">
                            {this.props.jackpotsUkupno && <p className="title">
                                {casino.utils.numberWithCurrencyFromated(this.props.jackpotsUkupno.iznos, this.props.jackpotsUkupno.valuta)}
                                <span className="kune">{casino.utils.switchCurrencyKnToEur()}</span>
                            </p>}
                            <p className="text"><strong>te još uvijek čeka u JACKPOTOVIMA!</strong> Više od 100 Hrvata i Hrvatica uz Supersport Casino postali su miljunaši!</p>
                            <div className="gumbi-container">
                                <a className="m-auto" href="https://m.supersport.hr/registracija"><button className="registriraj" type="button">REGISTRIRAJ SE SADA</button></a>
                                <a className="m-auto" href="https://mcasino.supersport.hr/?promocija=najveci-jackpot-v2"><button className="kasino" type="button">NASTAVI NA CASINO <span className="icon ico-chevron-right"></span></button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    renderInfoPage() {
        return <>

            <div className="info-landing-flickity-slider">
                <div className="flickity-item">{this.renderCasinoPage(true)}</div>
                <div className="flickity-item">{this.renderJackpotPage(true)}</div>
                <div className="flickity-item">{this.renderPokerPage(true)}</div>                
            </div>
            <div className={"info-landing-bg-image " + this.state.activeSlideClass}></div>
        </>

    }

    render() {

        var landingInfoPage = this.props.route.match.params.landingPage;

        return <div>
            <MetaTags title="Info - Casino | Najbolji Online Casino u Hrvatskoj | SuperSport | SuperCasino" description={"Zaviri u listu dobitnika u SuperSport CASINU!"} />

            <Header key="header" {...this.state} {...this.props}></Header>

            <div id="page-wrapper" className="no-padding grey">
                {!landingInfoPage &&
                    <div className="margin-center info-landing">
                        {this.renderInfoPage()}
                    </div>}


                {/*!landingInfoPage && <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                    <div className="error-message margin-top  padding-sides-medium ">
                        <span className="icon ico-alert"></span>
                        <span>Stranica nije pronađena.</span>
                    </div>
                    <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                    <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                    <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                </div>*/}


                {landingInfoPage == 'casino' &&
                    <div className="margin-center info-landing">
                        {this.renderCasinoPage()}
                    </div>}

                {landingInfoPage == 'jackpot' &&
                    <div className="margin-center info-landing">
                        {this.renderJackpotPage()}
                    </div>}

                {landingInfoPage == 'poker' &&
                    <div className="margin-center info-landing">
                        {this.renderPokerPage()}
                    </div>}
            </div>

            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
};
